import ArticleListingCard from "../../articleListingCard/articleListingCard"

import styles from "./twoColumnArticleListingLayout.module.scss"

function TwoColumnArticleListingLayout({ articles }) {
  const middle = Math.ceil(articles.length / 2)

  const col1articles = articles.slice(0,middle),
        col2articles = articles.slice(middle)

  return (
    <>
      <div className={styles.layout}>
        <div className={styles.col1}>
          {col1articles.map((a,idx)=>(
            <ArticleListingCard
              layout={idx === 0 ? "featured" : "inlineSmall"}
              key={a.uuid}
              slug={a.slug}
              thumbnail={a.content.thumbnail}
              authors={a.content.authors}
              title={a.content.headline}
              summary={a.content.lead}
              date={a.content.created_at}
              article_category={a.content.category}
              article_type={a.content.article_type}
              comment_count={5}
              enable_comments={a.content.has_comments}
              enable_social_sharing={a.content.has_social_sharing}
              use_legacy_thumbnail_background={a.content.legacy_thumbnail_background}
            />
          ))}
        </div>
        <div className={`${styles.col2} ${styles.splitter}`}>
          {col2articles.map((a,idx)=>(
            <ArticleListingCard
              layout={idx === 0 ? "featured" : "noImage"}
              key={a.uuid}
              slug={a.slug}
              thumbnail={a.content.thumbnail}
              authors={a.content.authors}
              title={a.content.headline}
              summary={a.content.lead}
              date={a.content.created_at}
              date_new_line={idx === 0}
              article_category={a.content.category}
              article_type={a.content.article_type}
              comment_count={5}
              enable_comments={a.content.has_comments}
              enable_social_sharing={a.content.has_social_sharing}
              use_legacy_thumbnail_background={a.content.legacy_thumbnail_background}
            />
          ))}
        </div>
      </div>
    </>
  )

}

export default TwoColumnArticleListingLayout
